/**
 * Chrome glyphs only — navigation, disclosure, close. Anything that should end
 * up as real artwork is logged in ASSETS_NEEDED.md instead of being drawn here.
 */
import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

function Glyph({ size = 20, children, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  )
}

export const IconDashboard = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M4 13a8 8 0 0 1 16 0" />
    <path d="M12 13l4-3" />
    <path d="M4 17h16" />
  </Glyph>
)

export const IconTransactions = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M4 8h13l-3-3" />
    <path d="M20 16H7l3 3" />
  </Glyph>
)

export const IconRecommendations = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M12 3v1M5 6l.7.7M19 6l-.7.7M4 13h1M19 13h1" />
    <path d="M9 17a5 5 0 1 1 6 0v2H9v-2Z" />
    <path d="M10 21h4" />
  </Glyph>
)

export const IconProgress = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M4 19V5" />
    <path d="M4 19h16" />
    <path d="M7 15l4-5 3 3 5-6" />
  </Glyph>
)

export const IconSettings = (p: IconProps) => (
  <Glyph {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
  </Glyph>
)

export const IconUpload = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M12 16V4" />
    <path d="m8 8 4-4 4 4" />
    <path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" />
  </Glyph>
)

export const IconChevron = (p: IconProps) => (
  <Glyph {...p}>
    <path d="m9 5 7 7-7 7" />
  </Glyph>
)

export const IconBack = (p: IconProps) => (
  <Glyph {...p}>
    <path d="m15 5-7 7 7 7" />
  </Glyph>
)

export const IconClose = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M6 6 18 18M18 6 6 18" />
  </Glyph>
)

export const IconMenu = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Glyph>
)

export const IconSearch = (p: IconProps) => (
  <Glyph {...p} size={p.size ?? 18}>
    <circle cx="11" cy="11" r="6" />
    <path d="m20 20-4.5-4.5" />
  </Glyph>
)

export const IconMore = (p: IconProps) => (
  <Glyph {...p}>
    <circle cx="6" cy="12" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="18" cy="12" r="1" />
  </Glyph>
)

export const IconFile = (p: IconProps) => (
  <Glyph {...p}>
    <path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7l-4-4Z" />
    <path d="M14 3v4h4" />
  </Glyph>
)
